<template>
  <div>
    <!-- Form Section -->
    <div class="bg-white p-4 rounded-md shadow mb-6">
      <h2 class="text-lg font-semibold mb-4">Blast Notifikasi</h2>
      <form @submit.prevent="sendBlast">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label class="block text-sm font-medium mb-1">Judul</label>
            <input v-model="form.title" type="text" placeholder="Masukkan judul notifikasi"
              class="border border-gray-300 rounded-md px-3 py-2 w-full" required />
          </div>
          <div>
            <label class="block text-sm font-medium mb-1">Topik</label>
            <input v-model="form.topic" type="text" placeholder="Misal: all, user, driver"
              class="border border-gray-300 rounded-md px-3 py-2 w-full" />
          </div>
          <div>
            <label class="block text-sm font-medium mb-1">Pesan</label>
            <input v-model="form.body" type="text" placeholder="Isi pesan notifikasi"
              class="border border-gray-300 rounded-md px-3 py-2 w-full" required />
          </div>
          <div>
            <label class="block text-sm font-medium mb-1">Route</label>
            <input v-model="form.route" type="text" placeholder="Isi router"
              class="border border-gray-300 rounded-md px-3 py-2 w-full" required />
          </div>
        </div>

        <div class="flex justify-end mt-4">
          <button type="submit" class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
            :disabled="loading">
            {{ loading ? 'Mengirim...' : 'Kirim Notifikasi' }}
          </button>
        </div>
      </form>
    </div>

    <!-- Table Section -->
    <!-- <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <span v-if="column.field === 'title'">{{ entry.title }}</span>
        <span v-else-if="column.field === 'topic'">{{ entry.topic || '-' }}</span>
        <span v-else-if="column.field === 'body'">{{ entry.body }}</span>
        <span v-else-if="column.field === 'created_at'">{{ entry.created_at | formatDate }}</span>
      </template>
</TableComponent> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    // TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
  },
  data: () => ({
    loading: false,
    form: {
      title: '',
      body: '',
      topic: '',
      route: ''
    },
    columns: [
      { label: 'Judul', field: 'title' },
      { label: 'Topik', field: 'topic' },
      { label: 'Pesan', field: 'body' },
      { label: 'Tanggal', field: 'created_at' },
    ],
    data: [
      {
        title: 'Promo Akhir Tahun!',
        topic: 'all',
        body: 'Dapatkan diskon 50% untuk semua pengguna.',
        created_at: '2025-11-04T10:00:00Z',
      },
    ],
  }),
  computed: {
    filteredData() {
      return (this.data || []).filter(item => item.title !== '')
    },
  },
  methods: {
    ...mapActions('notification', ['notif']),
    async sendBlast() {
      this.loading = true
      try {
        this.notif({
          payloads: {
            title: this.form.title,
            topic: this.form.topic,
            body: this.form.body,
            route: this.form.route
          }
        })
        this.$toast.success('Notifikasi berhasil dikirim!')
        // Tambahkan hasil ke tabel untuk log sederhana
        this.data.unshift({
          title: this.form.title,
          topic: this.form.topic,
          body: this.form.body,
        })
        // Reset form
        this.form = { title: '', body: '', topic: '' }
      } catch (err) {
        console.error(err)
        this.$toast.error('Gagal mengirim notifikasi')
      } finally {
        this.loading = false
      }
    },
  },
  filters: {
    formatDate(val) {
      if (!val) return '-'
      const d = new Date(val)
      return d.toLocaleString('id-ID', { dateStyle: 'short', timeStyle: 'short' })
    },
  },
}
</script>

<style lang="">
</style>
